import "core-js/modules/web.dom-collections.iterator.js";
const warnings = new Set();

function warnOnce(message) {
  if (process.env.NODE_ENV !== "production") {
    if (!warnings.has(message)) {
      warnings.add(message); // eslint-disable-next-line no-console

      console.warn(message);
    }
  }
}

export { warnOnce };